/**
 * Discount code: copies the code beside the button and confirms it there.
 */
(function () {
  'use strict';

  if (window.__axiomDiscountCodeBound) return;
  window.__axiomDiscountCodeBound = true;

  function copy(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    // Fallback for browsers without the async clipboard.
    var field = document.createElement('textarea');
    field.value = text;
    field.setAttribute('readonly', '');
    field.style.position = 'fixed';
    field.style.opacity = '0';
    document.body.appendChild(field);
    field.select();
    try {
      document.execCommand('copy');
    } finally {
      field.remove();
    }
    return Promise.resolve();
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-discount-code-copy]');
    if (!button) return;
    var wrap = button.closest('[data-discount-code]');
    var value = wrap && wrap.querySelector('[data-discount-code-value]');
    if (!value) return;
    copy(value.textContent.trim()).then(function () {
      if (!button.dataset.label) button.dataset.label = button.textContent.trim();
      button.textContent = button.dataset.copiedLabel || button.dataset.label;
      clearTimeout(button._resetTimer);
      button._resetTimer = setTimeout(function () {
        button.textContent = button.dataset.label;
      }, 2000);
    });
  });
})();
